import { render, staticRenderFns } from "./LoginMsgPanel.vue?vue&type=template&id=bdda2968&scoped=true"
import script from "./LoginMsgPanel.vue?vue&type=script&lang=js"
export * from "./LoginMsgPanel.vue?vue&type=script&lang=js"
import style0 from "./LoginMsgPanel.vue?vue&type=style&index=0&id=bdda2968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda2968",
  null
  
)

export default component.exports